import React from "react";
import LogoDark from "../assets/LogoDark.svg";

const Logo = () => {
  return (
    <div>
      <img src={LogoDark} alt="Logo" />
    </div>
  );
};

export default Logo;
